import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { AjsResponse, wrapAjs } from '../ajs-response';

/**
 * SystemApiService (Angular 18) — HTTP wrappers for system-level endpoints.
 *
 * Replaces the AngularJS legacy service at:
 *   apps/b2b-ui/common/services/api/systemApi/systemApi.service.js
 *
 * Exposed as `apiService.system.*` through the ApiService facade
 * (downgraded under the legacy name for the 396 b2b-ui consumers).
 */
@Injectable({ providedIn: 'root' })
export class SystemApiService {
  private http = inject(HttpClient);

  csrf(): Promise<AjsResponse<unknown>> {
    return wrapAjs(this.http.get<unknown>('/v2/api/csrf'));
  }

  preFlightCheck(props?: { hostName: string }): Promise<AjsResponse<unknown>> {
    return wrapAjs(
      this.http.get<unknown>('/v2/api/auth/resolve', {
        params: props ? { hostName: props.hostName } : undefined,
      }),
    );
  }

  uuidObjectRegistry(props: { uuid: string }): Promise<AjsResponse<unknown>> {
    return wrapAjs(this.http.get<unknown>(`/v2/api/uuidobjectregistry/${props.uuid}`));
  }
}
